import useWindowSize from '@rehooks/window-size';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { CSSTransition } from 'react-transition-group';

import ReturnButton from 'modules/shared/components/ReturnButton/ReturnButton';
import StandardButton from 'modules/shared/components/StandardButton/StandardButton';

import { BLUE_BORDER } from 'constants/index';

import phone6 from 'static/assets/phone-6.png';

const ManualPageStepMyTaxGosuslugi = ({ returnBack, setStepGoToWallet }) => {
  const [isRendered, setIsRendered] = useState(false);
  const windowSize = useWindowSize();

  const taxGosuslugiRegistrationList = [
    {
      id: 1,
      text: (
        <>
          Выберите в качестве способа регистрации {'  '}
          <b>Через портал Госуслуг</b>
        </>
      ),
    },
    {
      id: 2,
      text: 'Авторизуйтесь на открывшейся странице Госуслуг привычным вам способом',
    },
  ];

  useEffect(() => {
    setIsRendered(true);
  }, []);

  return (
    <div className="manual-page__content-wrap">
      <CSSTransition
        classNames="animation-manual"
        in={isRendered}
        timeout={{ enter: 100, exit: 100, enterDelay: 100 }}
        unmountOnExit
      >
        <div className="manual-page__col">
          <ReturnButton onClick={returnBack} className="manual-page__return-link" />

          <h1 className="manual-page__title">Регистрация через Госуслуги</h1>

          {windowSize.innerWidth <= 760 && (
            <img src={phone6} alt="" className="manual-page__phone manual-page__phone_6" />
          )}

          <div className="manual-page__text">
            Портал Госуслуг - это тот личный кабинет, которым вы обычно пользуетесь на сайте
            gosuslugi.ru для того, чтобы заказать госуслуги в электронной форме, оплатить штрафы и
            задолженности, услуги ЖКХ и другое.
          </div>

          <ol className="manual-page__text-list">
            {taxGosuslugiRegistrationList.map(item => (
              <li className="manual-page__list-item" key={item.id}>
                <p className="manual-page__list-item-number">{item.id}</p>
                <div className="manual-page__list-item-text">{item.text}</div>
              </li>
            ))}
          </ol>

          <div className="manual-page__button-list">
            <StandardButton
              title="Далее"
              isLink={false}
              className="manual-page__button-item"
              onClick={setStepGoToWallet}
              bgType={BLUE_BORDER}
            />
          </div>
        </div>
      </CSSTransition>

      <CSSTransition
        classNames="animation-manual"
        in={isRendered && windowSize.innerWidth > 760}
        timeout={{ enter: 100, exit: 100, enterDelay: 100 }}
        unmountOnExit
      >
        <div className="manual-page__col">
          <img src={phone6} alt="" className="manual-page__phone manual-page__phone_6" />
        </div>
      </CSSTransition>
    </div>
  );
};

ManualPageStepMyTaxGosuslugi.propTypes = {
  returnBack: PropTypes.func.isRequired,
  setStepGoToWallet: PropTypes.func.isRequired,
};

export default ManualPageStepMyTaxGosuslugi;
